import FarmShareBG from '../../assets/FarmshareBG.jpg';
import { Navbar } from '../../components/Navbar';

import { useSelector, useDispatch } from 'react-redux';
import {
  getAllUsers,
  deleteUser,
  updateUser,
  clearError,
  register,
} from '../../redux/slices/userSlice';
import { useEffect, useState } from 'react';
import { DeleteUserModal } from '../../components/DeleteUserModal';

import { UpdateUserModal } from '../../components/UpdateUserModal';

import { AddUserModal } from '../../components/AddUserModal';

import { UserTable } from '../../components/UserTable';

import { LoadingModal } from '../../components/LoadingModal';

const UserList = () => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.users.users);
  const loading = useSelector((state) => state.users.loading);
  const error_message = useSelector((state) => state.users.error);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [addUserModal, setAddUserModal] = useState(false);
  const [changeUser, setChangeUser] = useState(null);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  useEffect(() => {
    dispatch(getAllUsers());
  }, [dispatch]);

  useEffect(() => {
    dispatch(clearError());
    return () => {
      dispatch(clearError());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!loading) {
      if (isUpdating) {
        setUpdateModal(false);
        setChangeUser(null);
        setSelectedUserData(null);
        setIsUpdating(false);
      }
      if (isDeleting) {
        setDeleteModal(false);
        setChangeUser(null);
        setIsDeleting(false);
      }
      if (isAdding) {
        setAddUserModal(false);
        setIsAdding(false);
      }
    }

    if (error_message) {
      setShowErrorModal(true);
    }
  }, [loading, error_message, isUpdating, isDeleting, isAdding]);

  useEffect(() => {
    if (changeUser) {
      const userData = users.find((user) => user._id === changeUser);
      if (userData) {
        setSelectedUserData(userData);
      }
    }
  }, [changeUser, users]);

  const handleDismissError = () => {
    setShowErrorModal(false);
    dispatch(clearError());
  };

  const roleOrder = { admin: 1, user: 2 };
  const sortedUsers = [...users].sort((a, b) => {
    const roleComparison = roleOrder[a.role] - roleOrder[b.role];
    if (roleComparison !== 0) return roleComparison;
    return a.email.localeCompare(b.email);
  });

  const handleUpdate = (e, updatedUserData) => {
    e.preventDefault();
    setIsUpdating(true);


    dispatch(updateUser(updatedUserData));
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsDeleting(true);
    dispatch(deleteUser(changeUser));
  };

  const handleAddUser = (formData) => {
    setIsAdding(true);
    dispatch(register(formData));
  };

  return (
    <div className="bg-sky-200">
      <Navbar src={FarmShareBG} pageName={`User List`} pageText={''} />

      {users.length === 0 && loading && !error_message && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-20 z-50">
          <LoadingModal message="Loading Users..." error={null} />
        </div>
      )}

      {showErrorModal && error_message && (
        <LoadingModal
          message="An error occurred"
          error={error_message}
          onClose={handleDismissError}
        />
      )}

      {updateModal && (
        <>
          {loading && isUpdating ? (
            <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
              <LoadingModal
                message="Updating user information..."
                error={error_message}
                onClose={error_message ? handleDismissError : null}
              />
            </div>
          ) : (
            <UpdateUserModal
              setUpdateModal={setUpdateModal}
              setChangeUser={setChangeUser}
              handleUpdate={handleUpdate}
              loading={loading}
              error={error_message}
              user={selectedUserData}
            />
          )}
        </>
      )}

      {deleteModal && (
        <>
          {loading && isDeleting ? (
            <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
              <LoadingModal
                message="Deleting user..."
                error={error_message}
                onClose={error_message ? handleDismissError : null}
              />
            </div>
          ) : (
            <DeleteUserModal
              handleDelete={handleDelete}
              setDeleteModal={setDeleteModal}
              setChangeUser={setChangeUser}
            />
          )}
        </>
      )}

      {addUserModal && (
        <>
          {loading && isAdding ? (
            <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
              <LoadingModal
                message="Adding new user..."
                error={error_message}
                onClose={error_message ? handleDismissError : null}
              />
            </div>
          ) : (
            <AddUserModal 
              setAddUserModal={setAddUserModal} 
              handleAddUser={handleAddUser}
            />
          )}
        </>
      )}

      {!(users.length === 0 && loading) && (
        <UserTable
          sortedUsers={sortedUsers}
          setDeleteModal={setDeleteModal}
          setUpdateModal={setUpdateModal}
          setChangeUser={setChangeUser}
          loading={loading}
          setAddUserModal={setAddUserModal}
        />
      )}
    </div>
  );
};

export { UserList };
